module.exports = __webpack_public_path__ + "static/img/pic-bg-active-3.46cb63a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-active-3.png
// module id = Kr+x
// module chunks = 0